// Verzuim — 3-status state-machine voor SickLeave (module C5).
//
// Bron-hiërarchie:
//   - Status-overgangen uit `apps/api/src/routes/sick-leave.ts` en
//     `packages/utils/src/sick-leave-calculations.ts` (`bepaalStatus`).
//   - BR #45: ≥7 dagen ziek → automatische promotie ACTIEF→LANGDURIG.
//   - Recover: ACTIEF/LANGDURIG → HERSTELD via PATCH /sick-leave/:id/recover.
//
// Workflow:
//   ACTIEF → LANGDURIG → HERSTELD
//          ↘ HERSTELD  (direct beter binnen 7 dagen)
//   HERSTELD is eindstaat — geen overgangen meer.

import { WorkflowEngine, type WorkflowDefinition } from '../workflow-engine'

/** Mirror van Prisma SickLeaveStatus enum. */
export type VerzuimStatusValue = 'ACTIEF' | 'LANGDURIG' | 'HERSTELD'

export const verzuimWorkflow: WorkflowDefinition<VerzuimStatusValue> = {
  name: 'verzuim',
  initial: 'ACTIEF',
  states: ['ACTIEF', 'LANGDURIG', 'HERSTELD'],
  transitions: [
    // 1. Promotie naar langdurig (cron-trigger of handmatig door HR)
    {
      from: 'ACTIEF',
      to: 'LANGDURIG',
      label: 'Markeer als langdurig',
      rolesAllowed: ['HR', 'TEAMLEIDER', 'ADMIN'],
    },
    // 2. Beter melden — vanuit ACTIEF of LANGDURIG
    {
      from: 'ACTIEF',
      to: 'HERSTELD',
      label: 'Beter melden',
      rolesAllowed: ['MONTEUR', 'TEAMLEIDER', 'HR', 'MANAGER', 'ADMIN'],
    },
    {
      from: 'LANGDURIG',
      to: 'HERSTELD',
      label: 'Beter melden',
      rolesAllowed: ['MONTEUR', 'TEAMLEIDER', 'HR', 'MANAGER', 'ADMIN'],
    },
  ],
}

/** Engine-instance voor verzuim — direct importeerbaar in API-routes. */
export const verzuimEngine = new WorkflowEngine(verzuimWorkflow)
